/// <amd-module name="Wit/WorkItemForm/Details/WorkItemFormCommentsShimmer" />
import { Coin, CoinSize } from "VSSUI/Coin";
import { css } from "VSSUI/Util";
import * as React from "react";

export type WorkItemFormCommentsShimmerProps = {
    newComment?: boolean;
    count?: number;
};
export const WorkItemFormCommentsShimmer: React.FC<WorkItemFormCommentsShimmerProps> = props => {
    const shimmers = [];
    for (let i = 0; i < (props.count ?? 1); ++i) {
        shimmers.push(<WorkItemFormCommentShimmer key={`shimmer-comment-${i}`} newComment={props.newComment ?? false} />);
    }
    return <div>{shimmers}</div>;
};

const generateShimmerRow = (key: string, className?: string, width?: string) => (
    <div
        key={key}
        className={css("shimmer", "shimmer-line", "wi-comment-shimmer", className)}
        style={{ width: width ? width : Math.random() * 40 + 60 + "%" }}
    >
        &nbsp;
    </div>
);

const WorkItemFormCommentShimmer: React.FC<{ newComment: boolean }> = props => {
    const shimmerRows = [];
    for (let i = 0; i < (props.newComment ? 2 : Math.random() * 5 + 2); ++i) {
        shimmerRows.push(generateShimmerRow(`shimmer-row-${i}`));
    }
    return props.newComment ? (
        <>
            <div className="wi-comment-shimmer-textarea">{shimmerRows}</div>
            {generateShimmerRow("", "wi-comment-shimmer-toolbar", "100%")}
        </>
    ) : (
        <div className="flex-row depth-8 wi-comment-shimmer-container">
            <Coin className="margin-8" displayName="&nbsp;" size={CoinSize.size24} />
            <div className="wi-comment-shimmers">{shimmerRows}</div>
        </div>
    );
};
